import type { IconSvgObject } from './types';

const HijabIcon: IconSvgObject = [
  ["path", { d: "M12 5C10.3431 5 9 6.34315 9 8V10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10V8C15 6.34315 13.6569 5 12 5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 10C15 12.5 14.4133 14.4 11 16C7.58667 17.6 7 20 7 21", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 8H15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17.9998 8C17.9998 4.95214 15.2045 2 12 2C8.79554 2 5.99981 4.95214 5.99981 8C5.99981 9.92648 4.65193 14.2463 2.57212 17.236C2.26685 17.6748 2.31344 18.2828 2.73151 18.6159C8.39473 23.128 15.6049 23.128 21.2681 18.6159C21.6862 18.2828 21.7328 17.6748 21.4275 17.236C19.3477 14.2463 17.9998 9.92648 17.9998 8Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default HijabIcon;
